import React from 'react';
import PropTypes from 'prop-types';
import {
	AreaChart,
	ResponsiveContainer,
	Area,
	CartesianGrid,
	XAxis,
	YAxis,
	Tooltip,
	Label,
} from 'recharts';

import './AveragePricesContent.scss';

export const formatMonth = (dateString) => {
	const [year, month] = dateString.split('-');
	const adjustedMonth = parseInt(month, 10) - 1; // JS months are 0 indexed
	const date = new Date(year, adjustedMonth);
	const options = { month: 'short', year: 'numeric' };
	return date.toLocaleDateString('en-US', options);
};

export const pickInterval = (viewportWidth) => {
	if (viewportWidth > 1299 || (viewportWidth > 730 && viewportWidth < 992)) {
		return 'preserveEnd';
	}
	return 1;
};

export function AveragePricesGraph({ priceHistory, viewportWidth }) {
	return (
		<div className="average-prices-graph">
			<ResponsiveContainer
				width="100%"
				height={400}
			>
				<AreaChart
					data={priceHistory}
					margin={{ top: 20, right: 20, left: 20, bottom: 20 }}
					overflow="visible"
				>
					<CartesianGrid
						horizontal
						vertical={false}
						strokeDasharray="3"
						opacity={0.5}
					/>
					<XAxis
						dataKey="date"
						tickFormatter={formatMonth}
						interval={pickInterval(viewportWidth)}
						type="category"
						axisLine={false}
						tickLine={false}
					>
						<Label
							value="Months"
							offset={-15}
							position="insideBottom"
							className="chart-label"
						/>
					</XAxis>
					<YAxis
						dataKey="price"
						tickFormatter={(value) => `$${value}`}
						axisLine={false}
						tickLine={false}
					>
						<Label
							value="Average Prices"
							offset={-15}
							dy={40}
							angle={-90}
							position="insideLeft"
							className="chart-label"
						/>
					</YAxis>
					<Tooltip formatter={(value) => `$${value}`} />
					<Area
						type="monotone"
						dataKey="price"
						stroke="#146FB4"
						fill="#146FB4"
						fillOpacity={0.2}
					/>
				</AreaChart>
			</ResponsiveContainer>
		</div>
	);
}

AveragePricesGraph.propTypes = {
	priceHistory: PropTypes.arrayOf(
		PropTypes.shape({
			date: PropTypes.string,
			price: PropTypes.number,
		}),
	).isRequired,
	viewportWidth: PropTypes.number.isRequired,
};

export default AveragePricesGraph;
